import usePrivateAxios from '@/common/api/usePrivateAxios'
import { InfocarRequestCacheResponse } from '@/features/modelIntegrationCodes/types/modelIntegrationCode.type'
import { useQuery } from '@tanstack/react-query'

interface UseInfocarRequestCacheProps {
  modelIntegrationCodeId?: string
  equipmentId?: string
}

export const useInfocarRequestCache = ({ modelIntegrationCodeId, equipmentId }: UseInfocarRequestCacheProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    queryKey: ['modelIntegrationCodes', 'infocarCache', modelIntegrationCodeId, equipmentId],
    enabled: !!modelIntegrationCodeId && !!equipmentId,
    queryFn: () =>
      privateAxios.get(`/equipment_models/${modelIntegrationCodeId}/show_infocar_request_cache`, {
        params: { equipment_id: equipmentId },
      }),
    select: (response: { data: { data: InfocarRequestCacheResponse } }) => response?.data?.data,
  })
}
